import { render, staticRenderFns } from "./HidePriceButton.vue?vue&type=template&id=ae81fb48&scoped=true"
import script from "./HidePriceButton.vue?vue&type=script&lang=js"
export * from "./HidePriceButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae81fb48",
  null
  
)

export default component.exports